import { io, type Socket } from 'socket.io-client';
import { BACKEND_URL } from '@/services/apiClient';

let _socket: Socket | undefined;

export const getSocket = (): Socket => {
  if (!_socket) {
    _socket = io(BACKEND_URL, { autoConnect: false });
  }
  return _socket;
};
